define('SageDotCom/Components/DynamicProductCard/DynamicProductCardUpdater',[
    "jquery",
    "SageDotCom/Components/ProductCardAlignment",
    "eventManager"
],
    ($, productCardAlignment, eventManager) => {
        function DynamicProductCardUpdater(
            scope,
            freeLabel,
            isPreview
        ) {
            if (!$(".dynamic-product-card-updater").length) {
                return;
            }

            const $updateButton = $(".dynamic-product-card-updater .updateButton", scope);
            const $newSkuField = $(".dynamic-product-card-updater .newSku", scope);
            if (!$updateButton.length || !$newSkuField.length) {
                return;
            }
            const $newBasePromoField = $(".dynamic-product-card-updater .newBasePromo", scope);
            const $checkboxCrossSellArea = $(".dynamic-product-card-updater .checkboxCrossSellArea", scope);
            const $checkboxCrossSell = $(".dynamic-product-card-updater .checkboxCrossSell", scope);
            const $crossSellOptions = $(".dynamic-product-card-updater .promo-overwrite-container", scope);
            const $productCardPrimaryButton = $(".sage-product-card-actions-area .product-card-cta-primary-alt");

            if (!$productCardPrimaryButton || !$productCardPrimaryButton.hasClass("dynamic-product-card-modal-launch-btn")) {
                $checkboxCrossSell.hide();
            }

            eventManager.subscribe("priceBoxInstanciated", () => {
                $newSkuField.val(window.productCardUpdater_productSku);
                if ($newBasePromoField.length > 0) {
                    $newBasePromoField.val(window.productCardUpdater_promoOverwrite);
                }
            });

            const IsNullOrEmpty = (str) => {
                return str === null || str === undefined || (typeof str === "string" && str.trim() === "");
            };

            function isValidInternalUrl(url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin);
                    return parsedUrl.origin === window.location.origin;
                } catch (e) {
                    return false;
                }
            }

            const UpdateProductCardButtonLink = (newSku, newBasePromo) => {
                if ($productCardPrimaryButton && $productCardPrimaryButton.length > 0 && newSku !== "") {
                    let datahref = $productCardPrimaryButton.attr("data-href");
                    let href = $productCardPrimaryButton.attr("href");

                    if (!IsNullOrEmpty(newSku)) {
                        if (datahref) {
                            datahref = datahref.replace(/(sku=)[^&]+/, "$1" + newSku);
                        }
                        if (href) {
                            href = href.replace(/(sku=)[^&]+/, "$1" + newSku);
                        }
                    }
                    if (!IsNullOrEmpty(newBasePromo)) {
                        if (datahref) {
                            datahref = datahref.replace(/(promocode=)[^&]+/, "$1" + newBasePromo);
                        }
                        if (href) {
                            href = href.replace(/(promocode=)[^&]+/, "$1" + newBasePromo);
                        }
                    }

                    if (datahref && isValidInternalUrl(datahref)) {
                        $productCardPrimaryButton.attr("data-href", datahref);
                    }
                    else if (href && isValidInternalUrl(href)) {
                        $productCardPrimaryButton.attr("href", href);
                    }
                }
            }

            const AddSpinner = ($element) => {
                if ($element.length) {
                    $element.addClass("icon-loader icon-loader-black");
                }
            }
            const RemoveSpinner = ($element) => {
                if ($element.length) {
                    $element.removeClass("icon-loader icon-loader-black");
                }
            }

            //checkbox crossSell and actions
            let isCrossSell = false;
            if ($checkboxCrossSell.length && $crossSellOptions.length) {
                const ToggleCrossSellInputs = (show) => {
                    if ($crossSellOptions && $crossSellOptions.length > 0) {
                        isCrossSell = show;
                        $crossSellOptions.toggle(show).attr("hidden", !show);
                    }
                }

                $checkboxCrossSell.change(() => {
                    ToggleCrossSellInputs($checkboxCrossSell.is(":checked"));
                    if (isCrossSell) {
                        const newSku = $newSkuField.val().trim();
                        const newBasePromo = $newBasePromoField.length > 0 ? $newBasePromoField.val().trim() : "";
                        AddSpinner($checkboxCrossSellArea);
                        UpdateProductCardButtonLink(newSku, newBasePromo);

                        // event to refresh dynamic product card cross-sell options
                        eventManager.trigger("productCardCrossSellUpdated",
                            newSku,
                            true
                        );
                        // event to refresh dynamic product card variables
                        eventManager.trigger("productCardUpdated",
                            newSku,
                            newBasePromo
                        );
                    } else {
                        $crossSellOptions.empty();
                        RemoveSpinner($checkboxCrossSellArea);
                    }
                });
            }

            const resetCrossSell = () => {
                $crossSellOptions.empty();
                RemoveSpinner($checkboxCrossSellArea);
                $checkboxCrossSell.prop("checked", false);
            }

            //click on updateButton and actions
            $updateButton.click(() => {
                var newSku = $newSkuField.val().trim();
                if (IsNullOrEmpty(newSku)) {
                    return;
                }
                var newBasePromo = $newBasePromoField ? $newBasePromoField.val().trim() : "";

                let newPromo;
                if (isCrossSell) {
                    const $combinedValues = $(".promo-input")
                        .map((index, promoInputSelector) =>
                            $(promoInputSelector).val()
                        ).get();

                    newPromo = $combinedValues.filter(value => value !== "").join("-");
                }

                if (newPromo) {
                    window.productCardUpdater_newPromo = newPromo;
                }

                // event to refresh dynamic product card variables
                eventManager.trigger("productCardUpdated",
                    newSku,
                    newBasePromo
                );

                const $pricebox = $(".dynamic-product-card-price-box");
                if ($pricebox.length > 0) {
                    const ignorePromo = $pricebox.hasClass("no-promo");

                    UpdateProductCardButtonLink(newSku, newBasePromo);

                    const locale = (() => {
                        if (isPreview) {
                            const currentUrl = new URL(window.location.href);
                            return currentUrl.searchParams.get("sc_lang") || "en";
                        }
                        const localeArr = document.location.pathname.split("/")
                            .filter(part => part !== "");
                        return localeArr.length > 0 ? localeArr[0] : "en";
                    })();

                    // AJAX call to Update basic productCard details
                    $.ajax({
                        url: `/sitecore/api/product/UpdateProductCard/${newSku}/${locale}`,
                        method: "GET",
                        data: {
                            promoCodeOverwrite: $newBasePromoField.length
                                ? $newBasePromoField.val().trim()
                                : window.productCardUpdater_promoOverwrite,
                            promoHtmlTemplate: window.productCardUpdater_promoLabel
                        },
                        success: (response) => {
                            let jsonObj;
                            try {
                                jsonObj = typeof response === "string" ? JSON.parse(response) : JSON.parse(response.data);
                            } catch (e) {
                                console.error("DynamicProductCardUpdater - updateButton action - Error parsing JSON response:", e);
                                resetCrossSell();
                                return;
                            }

                            if (!jsonObj || !jsonObj.FormattedPrice) {
                                console.log("DynamicProductCardUpdater - Empty or invalid response received. Cannot update product price.");
                                resetCrossSell();
                                return;
                            }

                            let productprice;
                            if (!ignorePromo && jsonObj.Promo && jsonObj.Promo.PromoHtml) {
                                $(".sage-dynamic-product-card-promotion-banner").html(jsonObj.Promo.PromoHtml);
                                $(".sage-dynamic-product-card-promo").html(jsonObj.Promo.PromoHtml).show();
                                $(".sage-dynamic-product-card.sage-product-card-price-box").addClass("promo");

                                if ($($pricebox).hasClass("display-discount-number") || $($pricebox).hasClass("display-discount-text")) {
                                    if ($($pricebox).hasClass("display-discount-text") && jsonObj.Promo.DiscountedPrice === 0) {
                                        productprice = freeLabel;
                                    }
                                    else {
                                        productprice = jsonObj.Promo.FormattedDiscountPrice;
                                    }
                                }
                                else {
                                    // must be default of display rrp chosen
                                    productprice = jsonObj.FormattedPrice;
                                }

                            }
                            else {
                                $(".sage-dynamic-product-card-promotion-banner").html("");
                                $(".sage-dynamic-product-card-promo").hide();
                                $(".sage-dynamic-product-card.sage-product-card-price-box").removeClass("promo");

                                productprice = jsonObj.FormattedPrice;
                            }

                            $(".sage-product-card-price-alt").html(productprice);

                            const comparisonTable = $pricebox.closest(".product-comparison-table");
                            const parentCard = $pricebox.closest(".sage-product-card-outer");

                            if (comparisonTable.length > 0 &&
                                parentCard.find(".sage-product-card-bundle-price-box").length === 0) {
                                eventManager.trigger("populate-comparison-header", null, $pricebox);
                            }

                            productCardAlignment.sageProductCardMatchHeight();
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            resetCrossSell();
                            let errorMessage = "an error occurred";
                            switch (jqXHR.status) {
                                case 400: errorMessage = `bad Request: payload is missing data - jqXHR.statusText: ${jqXHR.statusText}`;
                                    break;
                                case 404: errorMessage = `data not found - jqXHR.statusText: ${jqXHR.statusText}}`;
                                    break;
                                case 500: errorMessage = `internal server error - jqXHR.statusText: ${jqXHR.statusText}}`;
                                    break;
                                default: errorMessage = `unexpected error - jqXHR.statusText: ${jqXHR.statusText}`;
                                    break;
                            }
                            console.error(`DynamicProductCardUpdater Error during AJAX call - ${errorMessage}`, textStatus, errorThrown);
                        }
                    });
                }
            });
        }

        DynamicProductCardUpdater.init = (args) => {
            return args.IsEditorEditing === true
                ? null
                : new DynamicProductCardUpdater(args.scope, args.freeLabel, args.isPreview);
        };

        return DynamicProductCardUpdater;
    });
